import { Tag } from "antd";

import {
  COLLECTIONS_CASE_STATUS_LABELS,
  COLLECTIONS_EVENT_KIND_LABELS,
  COLLECTIONS_SITUATION_LABELS,
  COLLECTIONS_STEP_LABELS,
  COLLECTIONS_TASK_TYPE_LABELS,
  CollectionsCaseStatus,
  type CollectionsCaseStatus as CaseStatus,
  type CollectionsEventKind,
  type CollectionsSituation,
  type CollectionsStep,
  type CollectionsTaskType,
} from "@fitness-app/data-models/entities/CollectionsCase";

import { getPriceFormatter } from "~/modules/Products/utils/getPriceFormatter";

const revenueFormatter = getPriceFormatter("PLN");

/**
 * KPI tiles wrap by their own width, not by breakpoints: next to the admin
 * sidebar a fixed 5-6 columns cut „254 725,80 zł" in half.
 */
export const KPI_GRID = "grid grid-cols-[repeat(auto-fill,minmax(210px,1fr))] gap-4";

export const formatPln = (grosze: number | null | undefined) =>
  grosze === null || grosze === undefined ? "—" : revenueFormatter.format(grosze / 100);

const STATUS_COLORS: Record<CaseStatus, string> = {
  new: "orange",
  recovering: "gold",
  awaiting_contact: "gold",
  awaiting_payment: "blue",
  demand_sent: "volcano",
  external_collection: "red",
  settlement: "blue",
  monitoring: "purple",
  closed_paid: "green",
  closed_settled: "green",
  closed_written_off: "default",
};

export const CaseStatusTag = ({ status }: { status: CaseStatus }) => (
  <Tag color={STATUS_COLORS[status] ?? "default"}>{COLLECTIONS_CASE_STATUS_LABELS[status] ?? status}</Tag>
);

export const SituationTag = ({ situation }: { situation: CollectionsSituation | null }) =>
  situation ? <Tag>{COLLECTIONS_SITUATION_LABELS[situation] ?? situation}</Tag> : null;

export const taskLabel = (type: CollectionsTaskType) => COLLECTIONS_TASK_TYPE_LABELS[type] ?? type;

export const eventLabel = (kind: CollectionsEventKind): string => COLLECTIONS_EVENT_KIND_LABELS[kind] ?? kind;

/** 1 rata, 2–4 raty, 5+ rat (and 12–14, 22–24… stay „rat"). */
export const pluralRaty = (count: number): string => {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (count === 1) return "rata";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "raty";
  return "rat";
};

export const STATUS_OPTIONS = Object.values(CollectionsCaseStatus).map((status) => ({
  value: status,
  label: COLLECTIONS_CASE_STATUS_LABELS[status],
}));

export const stepLabel = (step: CollectionsStep | string | null | undefined): string =>
  step ? (COLLECTIONS_STEP_LABELS[step as CollectionsStep] ?? String(step)) : "—";

/** Powody, dla których wysyłka pominęła sprawę — z `holds` w podsumowaniu przebiegu. */
export const holdLabel = (hold: string | null): string => {
  if (!hold) return "—";
  if (hold.startsWith("status:"))
    return `wstrzymane: ${COLLECTIONS_CASE_STATUS_LABELS[hold.slice(7) as CaseStatus] ?? hold.slice(7)}`;
  switch (hold) {
    case "nothing_due":
      return "nic nie jest jeszcze należne";
    case "ladder_finished":
      return "wszystkie wiadomości wysłane, czeka na decyzję";
    case "automation_off":
      return "wysyłka wyłączona";
    case "no_unpaid_invoices":
      return "brak nieopłaconych rat";
    default:
      return hold;
  }
};
